import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  addSect,
  deleteSect,
  getSect,
  updateSect,
} from "store/services/dataManagement/sect";
import { closeAdminModal } from "store/slices/common/adminModal.slice";
import { openToast } from "store/slices/common/toast.slice";
import { getApiMessage } from "utils/apiErrorCode";

//Get All sect
export const GetAllSectAction = createAsyncThunk(
  "sect/get",
  async (payload, { rejectWithValue, fulfillWithValue }) => {
    try {
      const res = await getSect(payload);
      if (res.status === 1) {
        // if any async operation need to be done on response data, do it here,
        // then full fill data
        return fulfillWithValue(res);
      }
      return rejectWithValue(res);
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

//Delete sect
export const DeleteSectAction = createAsyncThunk(
  "sect/delete",
  async (payload, { rejectWithValue, dispatch, fulfillWithValue }) => {
    try {
      const { filter, onSuccess, ...rest } = payload;
      const res = await deleteSect(rest);
      if (res.status === 1) {
        // if any async operation need to be done on response data, do it here,
        // then full fill data
        if (onSuccess) onSuccess();
        const responce = await getSect(filter);
        if (responce.status === 1) {
          return fulfillWithValue(responce);
        }
      }
      dispatch(
        openToast({ type: "error", message: getApiMessage(res?.statusCode) }),
      );
      return rejectWithValue(res);
    } catch (error) {
      dispatch(
        openToast({
          type: "error",
          message: error?.response?.data?.statusCode
            ? getApiMessage(error?.response?.data?.statusCode)
            : error?.message,
        }),
      );
      return rejectWithValue(error);
    }
  },
);

//Update sect
export const UpdateSectAction = createAsyncThunk(
  "sect/update",
  async (payload, { rejectWithValue, dispatch, fulfillWithValue }) => {
    let { onSucess, ...rest } = payload;
    try {
      const res = await updateSect(rest);
      if (res.status === 1) {
        // if any async operation need to be done on response data, do it here,
        // then full fill data
        if (onSucess) onSucess();

        dispatch(closeAdminModal());
        return fulfillWithValue(res);
      }
      dispatch(
        openToast({ type: "error", message: getApiMessage(res?.statusCode) }),
      );
      return rejectWithValue(res);
    } catch (error) {
      dispatch(
        openToast({
          type: "error",
          message: error?.response?.data?.statusCode
            ? getApiMessage(error?.response?.data?.statusCode)
            : error?.message,
        }),
      );
      return rejectWithValue(error);
    }
  },
);

//Add sect
export const AddSectAction = createAsyncThunk(
  "sect/add",
  async (payload, { rejectWithValue, dispatch, fulfillWithValue }) => {
    try {
      const { filter, ...rest } = payload;
      const res = await addSect(rest);
      if (res.status === 1) {
        // if any async operation need to be done on response data, do it here,
        // then full fill data

        dispatch(closeAdminModal());
        const response = await getSect(filter);
        if (response.status === 1) {
          return fulfillWithValue(response);
        }
      }
      dispatch(
        openToast({ type: "error", message: getApiMessage(res?.statusCode) }),
      );
      return rejectWithValue(res);
    } catch (error) {
      dispatch(
        openToast({
          type: "error",
          message: error?.response?.data?.statusCode
            ? getApiMessage(error?.response?.data?.statusCode)
            : error?.message,
        }),
      );
      return rejectWithValue(error);
    }
  },
);
